module.exports = __webpack_public_path__ + "static/team-27-f57159441d90b635f74192b7398b5c28.jpg";